// The tonal design's tokens (TONAL_DESIGN_SYSTEM.md), lifted from the
// portfolio revamp so the Earnings hub and the portfolio share one set:
// tonal layering instead of borders, and one orchestrated load motion.

export interface TonalTokens {
  surface: string;
  raised: string;
  hairline: string;
  text: string;
  muted: string;
  faint: string;
  gain: string;
  loss: string;
  /** Red for text at 14px or under: `loss` on `surface` is below AA there. */
  lossText: string;
  /** Green for text at 14px or under: light `gain` on `surface` is below AA there. */
  gainText: string;
  track: string;
}

const DARK: TonalTokens = {
  surface: "#232323",
  raised: "#2a2a2a",
  hairline: "rgba(255, 255, 255, 0.06)",
  text: "#f5f5f5",
  muted: "#9ca3af",
  faint: "#6b7280",
  gain: "#22c55e",
  loss: "#ef4444",
  lossText: "#f87171",
  gainText: "#22c55e",
  track: "rgba(255, 255, 255, 0.08)",
};

const LIGHT: TonalTokens = {
  surface: "#f5f5f6",
  raised: "#ececee",
  hairline: "rgba(0, 0, 0, 0.08)",
  text: "#111111",
  muted: "#6b7280",
  faint: "#9ca3af",
  gain: "#16a34a",
  loss: "#dc2626",
  lossText: "#c81e1e",
  gainText: "#15803d",
  track: "rgba(0, 0, 0, 0.07)",
};

export const tonalTokens = (isDark: boolean): TonalTokens =>
  isDark ? DARK : LIGHT;

export const TABULAR = { fontVariantNumeric: "tabular-nums" } as const;

/** The load sequence's one curve, for framer-motion and for CSS. */
export const LOAD_EASE = [0.2, 0.8, 0.2, 1] as const;
export const LOAD_EASE_CSS = "cubic-bezier(0.2, 0.8, 0.2, 1)";

/** A flat card: a filled surface one step off the page; no border, outline or shadow. */
export const cardSx = (tokens: TonalTokens) =>
  ({
    position: "relative",
    backgroundColor: tokens.surface,
    borderRadius: "12px",
    minWidth: 0,
  }) as const;

export const cardTitleSx = (tokens: TonalTokens) =>
  ({
    fontSize: "0.9375rem",
    fontWeight: 600,
    color: tokens.text,
    lineHeight: 1.4,
  }) as const;
